import { render, staticRenderFns } from "./editstore.vue?vue&type=template&id=42c148b0&scoped=true"
import script from "./editstore.vue?vue&type=script&lang=js"
export * from "./editstore.vue?vue&type=script&lang=js"
import style0 from "./editstore.vue?vue&type=style&index=0&id=42c148b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c148b0",
  null
  
)

/* custom blocks */
import block0 from "./editstore.vue?vue&type=custom&index=0&blockType=div&style=max-width%3A403px%3Bmax-height%3A300px"
if (typeof block0 === 'function') block0(component)

export default component.exports